/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_To_RenovateInputs */

const cs_enum_to_renovate = /** @type {(inputs: Enum_To_RenovateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`K rekonstrukci`)
};

const en_enum_to_renovate = /** @type {(inputs: Enum_To_RenovateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To renovate`)
};

/**
* | output |
* | --- |
* | "To renovate" |
*
* @param {Enum_To_RenovateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_to_renovate = /** @type {((inputs?: Enum_To_RenovateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_To_RenovateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_to_renovate(inputs)
	return cs_enum_to_renovate(inputs)
});